

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

require('xo-address-components/src/add-address/directive');

var _logger = require('xo-beaver/dist/logger');

require('xo-form-components/src/select-shipping-country/directive');

require('xo-form-components/src/zipcode/directive');

var _index = require('xo-models/src/address/index');

var _index2 = require('xo-models/src/checkout/index');

require('xo-tray-height/dist/directive');

require('xo-ui-components/src/accessibility/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-ui-components/src/message/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoShippingAddress', function () {
    return {
        template: _template2['default'],
        scope: {
            auth: '=?',
            token: '=?',
            doneFn: '=?',
            sidebar: '=?',
            update: '=?',
            renderBillingAddCheckbox: '=?',
            backUri: '=?',
            doneUri: '=?',
            shippingChangeFeature: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            if (!$scope.sidebar) {
                $scope.pageTitle = (0, _squid.$renderContent)('addShipping.addAddress');
            }
            $scope.backUri = $scope.backUri || 'checkout.review.sidebar.shipping';
            $scope.heading = $scope.update ? 'addressNormalization.update' : 'asideHeader.addShipping';
            $scope.buttonLabel = function () {
                if (!$scope.sidebar || $scope.address.country === 'BR' && !$scope.prefilled) {
                    return (0, _squid.$renderContent)('common.continueLabel');
                } else {
                    return (0, _squid.$renderContent)('common.save');
                }
            };
            $scope.address = {
                country: _squid.$locale.getCountryCodeISO()
            };
            $scope.isShipping = true;
            $scope.normalize = function () {
                return (0, _squid.$feature)('addressNormalization') && (0, _squid.$feature)('shippingAddressNormalization') && $scope.address.country === _squid.$locale.country // Should be domestic address
                && !$scope.normalized;
            };

            $scope.showshipping = true;
            $scope.country = _squid.$locale.country;
            $scope.recipient = {
                first_name: '',
                last_name: ''
            };

            var $el = $($element);

            function focusFirstError() {
                $el.find('form').find('.backendError, .ng-invalid').first().focus();
            }

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
                var contingencyPrefilledAddress = void 0;

                if ((0, _squid.$feature)('supportBlockNonDomesticShipping', false, merchantCountry)) {

                    $scope.disableChangeShippingCountry = $scope.checkoutAppData.get('flags.block_non_domestic_shipping', false);

                    if ($scope.disableChangeShippingCountry) {

                        $scope.address.country = merchantCountry;

                        contingencyPrefilledAddress = $scope.checkoutSession.get('errorData.resolution.data', null);
                        if (!$scope.sidebar && contingencyPrefilledAddress) {
                            angular.extend($scope.address, {
                                line1: contingencyPrefilledAddress.line1,
                                line2: contingencyPrefilledAddress.line2,
                                city: contingencyPrefilledAddress.city,
                                state: contingencyPrefilledAddress.state,
                                postal_code: contingencyPrefilledAddress.postal_code
                            });
                        }

                        _logger.$logger.info('member_block_non_domestic_shipping', {
                            block_non_domestic_shipping: $scope.disableChangeShippingCountry,
                            sidebar: $scope.sidebar
                        });

                        var countryName = (0, _squid.$renderContent)('shippingCountry.' + merchantCountry);
                        var infoMessage = (0, _squid.$renderContent)('largeScreenPayment.blockNonDomesticShippingAlert', {
                            shippingCountry: countryName
                        });

                        $scope.message = {
                            msgs: [infoMessage],
                            type: 'warning'
                        };
                    }
                }

                $scope.prefill = function () {
                    $scope.prefillAddress = new _index.$PrefillAddressModel({
                        id: $scope.token,
                        address: {
                            country: _squid.$locale.country,
                            postal_code: $scope.address.postal_code
                        }
                    });

                    $scope.prefillAddress.save({
                        data: $scope.prefillAddress,
                        success: function success(result) {
                            if (result) {
                                $scope.address = result;
                            }
                            $scope.prefilled = true;
                            $scope.address.first_name = $scope.recipient.first_name;
                            $scope.address.last_name = $scope.recipient.last_name;

                            (0, _angular.$timeout)(function () {
                                var value = $scope.address.state;
                                var $option = $el.find('[value="' + value + '"]');

                                $option.prop('selected', 'selected');
                                $option.trigger('change');

                                value = $option.attr('label');
                                focusFirstError();
                            }, 1000);
                        }
                    });
                };

                if ($scope.update) {
                    if ($scope.checkoutSession.shipping.name) {
                        var name = $scope.checkoutSession.shipping.name.trim();
                        var index = name.indexOf(' ');

                        $scope.recipient.first_name = name.substr(0, index);
                        $scope.recipient.last_name = name.substr(index + 1);
                    }
                    $scope.address.postal_code = $scope.checkoutSession.get('shipping.postal_code', '');
                    $scope.prefill();
                }

                function handleValidation(res) {
                    if (res && res.fields && res.fields.length) {
                        res.fields.forEach(function (field) {
                            if (field.field) {
                                var $field = $($el.find('[ng-model="address.' + field.field + '"]'));

                                if ($field.length === 0 && field.field === 'zip') {
                                    $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                                }
                                $field.addClass('backendError');
                                $field.attr('aria-invalid', true);
                            }
                        });
                        focusFirstError();
                    }
                }

                $scope.cancelFn = function () {
                    _uiRouter.$state.go('checkout.review.sidebar.shipping');
                };

                $scope.onSubmit = function () {
                    if ($scope.address.country === 'BR' && $scope.address.country === _squid.$locale.country && !$scope.prefilled) {
                        return $scope.prefill();
                    }

                    if ($scope.normalize()) {
                        $scope.showshipping = false;
                        _uiRouter.$state.go('.addressNormalization');
                    } else {
                        $scope.submitAddress();
                    }
                };

                $scope.removeValidation = function () {
                    $el.find('form').removeClass('validated');
                };

                function prefilledAddressUnchanged(prefilledAddress, addressToSubmit) {

                    function lowercaseEquals(str1, str2) {
                        return angular.lowercase(str1) === angular.lowercase(str2);
                    }

                    return lowercaseEquals(prefilledAddress.recipient_name, addressToSubmit.recipient_name) && lowercaseEquals(prefilledAddress.line1, addressToSubmit.line1) && lowercaseEquals(prefilledAddress.line2, addressToSubmit.line2) && lowercaseEquals(prefilledAddress.city, addressToSubmit.city) && lowercaseEquals(prefilledAddress.state, addressToSubmit.state) && lowercaseEquals(prefilledAddress.postal_code, addressToSubmit.postal_code) && lowercaseEquals(prefilledAddress.country_code, addressToSubmit.country);
                }

                function callOnShippingChange(callback) {
                    if ($scope.shippingChangeFeature && $scope.shippingChangeFeature.callOnShippingChange) {
                        $scope.shippingChangeFeature.callOnShippingChange(callback);
                    } else {
                        callback();
                    }
                }

                function updateAddress(payload) {
                    $scope.checkoutSession.shipping.action('update', {
                        data: payload,
                        resultModel: $scope.checkoutSession,
                        success: function success(result) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['smallToolTip.addressAdded']
                            };

                            callOnShippingChange(function () {
                                return $scope.doneFn(result);
                            });
                        },
                        validation: function validation(res) {
                            handleValidation(res);
                        }
                    });
                }

                function addAddress(payload) {
                    // make sure this param is not passed as behavior from symphony is erratic.
                    delete payload.address_id;
                    $scope.shippingAddress = _index2.$ShippingAddressModel.create($scope.token, payload);
                    $scope.shippingAddress.save({
                        data: payload,
                        resultModel: $scope.checkoutSession,
                        success: function success(result) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['smallToolTip.addressAdded']
                            };

                            callOnShippingChange(function () {
                                return $scope.doneFn($scope.address.isBA ? payload : null);
                            });
                        },
                        validation: function validation(res) {
                            handleValidation(res);
                        },
                        contingencies: {
                            'SHIPPING_ADDRESS_INVALID': function SHIPPING_ADDRESS_INVALID() {
                                $scope.message = {
                                    type: 'error',
                                    msgKeys: ['shippingAddress.errorInfo']
                                };
                            }
                        }
                    });
                }

                $scope.submitAddress = function () {
                    if ($scope.address.preferred_address) {
                        _logger.$logger.info('addAddrPreferred.selected', {});
                    }

                    var country = $scope.address.country;
                    // keep this for compatibility
                    var recipient_name = $scope.address.first_name + ' ' + $scope.address.last_name;

                    if ((0, _squid.$feature)('nameFormat', country, country) === 'LastFirst') {
                        recipient_name = $scope.address.last_name + ' ' + $scope.address.first_name;
                    }

                    var data = {
                        recipient_name: recipient_name,
                        first_name: $scope.address.first_name,
                        last_name: $scope.address.last_name,
                        line1: $scope.address.line1,
                        line2: $scope.address.line2,
                        city: $scope.address.city,
                        state: $scope.address.state,
                        postal_code: $scope.address.postal_code,
                        country: country,
                        normalization_status: $scope.address.normalization_status,
                        preferred_address: $scope.address.preferred_address,
                        default_address: true
                    };

                    if (contingencyPrefilledAddress && prefilledAddressUnchanged(contingencyPrefilledAddress, data)) {
                        data.address_id = contingencyPrefilledAddress.id;
                    }
                    // Update is used for the address normalization flow.
                    data.address_id = data.address_id ? data.address_id : $scope.checkoutSession.get('shipping.id');
                    if ($scope.update && data.address_id) {
                        updateAddress(data);
                    } else {
                        addAddress(data);
                    }
                };

                $scope.uponNormalization = function (normalizedAddress, isBack) {
                    if (isBack) {
                        $scope.normalized = false;
                        $scope.showshipping = true;
                        _uiRouter.$state.go('^');
                    } else {
                        $scope.address = normalizedAddress;
                        $scope.normalized = true;
                        $scope.address.first_name = $scope.recipient.first_name;
                        $scope.address.last_name = $scope.recipient.last_name;
                        $scope.submitAddress();
                    }
                };
            });
        }]
    };
});

_angular.$timeout;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$renderContent;

_uiRouter.$state;

_logger.$logger;

_index.$PrefillAddressModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutSessionModel;

_index2.$ShippingAddressModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js
// module id = ../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js
// module chunks = 0